import React from 'react';
import { useSession } from '../contexts/SessionContext';
import { SiteHeader } from './SiteHeader';
import { SiteFooter } from './SiteFooter';
import { IncompleteRegistrationBanner } from './IncompleteRegistrationBanner';
import { ChampionBanner } from './ChampionBanner';
type PageShellProps = {
  children: React.ReactNode;
  championBannerLayout?: 'contained' | 'fullBleed';
  showChampionBanner?: boolean;
};
const container = 'mx-auto w-full max-w-[1600px] border-x border-gray-300 bg-white';
export function PageShell({
  children,
  championBannerLayout = 'contained',
  showChampionBanner = true
}: PageShellProps) {
  const {
    isLoggedIn,
    hasIncompleteRegistration,
    championEligible,
    championBannerDismissed
  } = useSession();
  const showIncomplete = isLoggedIn && hasIncompleteRegistration;
  const championVisible = isLoggedIn && championEligible && showChampionBanner && !championBannerDismissed;
  return <div className="flex min-h-screen w-full flex-col bg-canvas" data-id="element-145" data-mp="2fu6fiv1hudui">
      <SiteHeader data-id="element-146" data-mp="dayrcxusq3n7" />
      <main className="flex-1 pb-16" data-id="element-147" data-mp="dagr7q50j5a0">
        {championBannerLayout === 'fullBleed' ? <>
            {showIncomplete && <div className={container} data-id="element-148" data-mp="8e8eejeafo60">
                <IncompleteRegistrationBanner data-id="element-149" data-mp="mcg7uhc487cf" />
              </div>}
            <ChampionBanner layout="fullBleed" visible={championVisible} data-id="element-150" data-mp="hctv09078t45" />
            <div className={`${container} ${championVisible ? 'mt-4' : ''}`} data-id="element-151" data-mp="hey7hfc5z0g1">{children}</div>
          </> : <div className={container} data-id="element-152" data-mp="rb182grdar0v">
            {showIncomplete && <IncompleteRegistrationBanner data-id="element-153" data-mp="rai11v399n1m" />}
            <ChampionBanner layout="contained" visible={championVisible} data-id="element-154" data-mp="152enbii8t2q3" />
            {children}
          </div>}
      </main>
      <SiteFooter data-id="element-155" data-mp="111vv3ncftund" />
    </div>;
}